var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCake1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9 17.2H4C3.44772 17.2 3 17.6477 3 18.2V21.75C3 22.3023 3.44772 22.75 4 22.75H28.9C29.4523 22.75 29.9 22.3023 29.9 21.75V18.2C29.9 17.6477 29.4523 17.2 28.9 17.2Z",
    fill: "url(#paint0_linear_20_28)",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9 23.8H4C3.44772 23.8 3 24.2477 3 24.8V28.35C3 28.9023 3.44772 29.35 4 29.35H28.9C29.4523 29.35 29.9 28.9023 29.9 28.35V24.8C29.9 24.2477 29.4523 23.8 28.9 23.8Z",
    fill: "url(#paint1_linear_20_28)",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12.2V14.7",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0998 10.9C20.7998 8.5 16.4998 3 16.4998 3C16.4998 3 12.0998 8.5 14.7998 10.9C15.2649 11.2819 15.848 11.4906 16.4498 11.4906C17.0516 11.4906 17.6347 11.2819 18.0998 10.9Z",
    fill: "url(#paint2_linear_20_28)",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_28",
    x1: 15,
    y1: 17.5,
    x2: 15,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7DAC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20_28",
    x1: 2.98152,
    y1: 29.3565,
    x2: 6.22347,
    y2: 17.3821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20_28",
    x1: 18.9904,
    y1: 11.4906,
    x2: 11.5177,
    y2: 7.03105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD15C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3AF00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCake1);
export default __webpack_public_path__ + "static/media/cake 1.0f9846865196b4d7e21d7f60601ac7e5.svg";
export { ForwardRef as ReactComponent };